import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BOIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BO" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#DB501C"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          stroke="#DB501C"
          strokeWidth={0.75}
          d="M5.824 5.63S5.638 7.534 7.33 7.534h1.261s1.781-.116 1.574-1.904"
        />
        <Path
          fill="#FECA00"
          stroke="#68B9E8"
          strokeWidth={0.75}
          d="M8 4.775a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Z"
        />
        <Path
          fill="#DB501C"
          fillRule="evenodd"
          d="M8 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="M8.05 6.8c.47 0 .85-.18.85-.4 0-.22-.38-.4-.85-.4s-.85.18-.85.4c0 .22.38.4.85.4Z"
          clipRule="evenodd"
        />
        <Path
          fill="#674F28"
          fillRule="evenodd"
          d="M8.05 5c.663 0 1.2-.18 1.2-.4 0-.221-.537-.4-1.2-.4-.663 0-1.2.179-1.2.4 0 .22.537.4 1.2.4Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
